import { CommonModule, CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { MatDialogModule } from '@angular/material/dialog';

import { environment } from '../environments/environment';

// Omnium UI
import { OuiAccordionModule } from 'omnium-ui/accordion';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiButtonToggle } from 'omnium-ui/button-toggle';
import { OuiChipModule } from 'omnium-ui/chip';
import { OuiDialogModule } from 'omnium-ui/dialog';
import {
  OuiAutocomplete,
  OuiCheckbox,
  OuiDatePickerModule,
  OuiRadioButton,
  OuiRadioButtonGroup,
  OuiRadioList,
  OuiSelect,
  OuiTextarea,
  OuiTextfield,
} from 'omnium-ui/form-field';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLayoutModule, OuiNavButtonModule, OuiNavigationPanelModule } from 'omnium-ui/layout';
import { OuiLoadingModule } from 'omnium-ui/loading';
import { OuiMenuModule } from 'omnium-ui/menu';
import { OuiNumber } from 'omnium-ui/number';
import { OuiPaginatorModule } from 'omnium-ui/paginator';
import { OuiSearchbar } from 'omnium-ui/searchbar';
import { OuiSelectFilter } from 'omnium-ui/select-filter';
import { OuiSlideToggle } from 'omnium-ui/slide-toggle';
import { OuiSnackbarModule } from 'omnium-ui/snackbar';
import { OuiStepper } from 'omnium-ui/stepper';
import { OuiTableModule } from 'omnium-ui/table';
import { OuiTabsModule } from 'omnium-ui/tabs';
import { OuiTagModule } from 'omnium-ui/tag';

import { OuiEtatVide } from 'omnium-ui/etat-vide';
import { OuiTooltipModule } from 'omnium-ui/tooltip';
import { AuthInterceptorInterceptor } from 'src/interceptors/auth-interceptor.interceptor';

import { OuiBanner } from 'omnium-ui/banner';
import { OuiFileItem } from 'omnium-ui/file-item';
import { OuiFileUploader } from 'omnium-ui/file-uploader';

import { ApplicationInsightsErrorHandler } from 'finzzle-angular-utils';

import { LibModule } from '@lib/lib.module';
import { OuiInfosBulle } from 'omnium-ui/infos-bulle';
import { ExigencesStepComponent } from 'src/app/components/declare-fiche-conseil/steps/exigences-step/exigences-step.component';
import { ObjectifCheckboxComponent } from 'src/app/components/declare-fiche-conseil/steps/exigences-step/objectif-checkbox/objectif-checkbox.component';
import { InvestisseurStepComponent } from 'src/app/components/declare-fiche-conseil/steps/investisseur-step/investisseur-step.component';
import { TransactionPersonelleComponent } from 'src/app/components/declare-fiche-conseil/steps/investisseur-step/transaction-personelle/transaction-personelle.component';
import { FicheConseilDashboardComponent } from 'src/app/components/my-fiches/fiche-conseil-dashboard/fiche-conseil-dashboard.component';
import { NoneActiveHabilitationMessageComponent } from 'src/app/components/none-active-habilitation-message/none-active-habilitation-message.component';
import { SearchInvestisseurAutocompleteComponent } from 'src/app/components/search-investisseur-autocomplete/search-investisseur-autocomplete.component';
import { GraphQLModule } from 'src/app/graphql.module';
import { CreateFicheConseilComponent } from './components/create-fiche-conseil/create-fiche-conseil.component';
import { SelectConseilConfigDialogComponent } from './components/create-fiche-conseil/select-conseil-config-dialog/select-conseil-config-dialog.component';
import { DeclareFicheConseilComponent } from './components/declare-fiche-conseil/declare-fiche-conseil.component';
import { DeprecationWarningDialogComponent } from './components/declare-fiche-conseil/deprecation-warning-dialog/deprecation-warning-dialog.component';
import { PrecisionComplementaireStepComponent } from './components/declare-fiche-conseil/steps/precision-complementaire-step/precision-complementaire-step.component';
import { AllocationAssetComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/allocation-asset/allocation-asset.component';
import { AllocationZoneLibreDualTextareaComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/allocation-asset/allocation-zone-libre-dual-textarea/allocation-zone-libre-dual-textarea.component';
import { AllocationConsultantFileUploadComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/allocation-asset/allocation-consultant-file-upload/allocation-consultant-file-upload.component';
import { AllocationRulesBannerComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/allocation-asset/allocation-rules-banner/allocation-rules-banner.component';
import { MotivationOperationComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/motivation-operation/motivation-operation.component';
import { ModeDeGestionComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/mode-de-gestion/mode-de-gestion.component';
import { FondsEvenementielCheckboxComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/mode-de-gestion/fonds-evenementiel-checkbox/fonds-evenementiel-checkbox.component';
import { OptionCheckboxComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/mode-de-gestion/option-checkbox/option-checkbox.component';
import { ProjetInvestissementStepComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/projet-investissement.component';
import { VersementComponent } from './components/declare-fiche-conseil/steps/projet-investissement-step/versement/versement.component';
import { StepConnaissanceClientComponent } from './components/declare-fiche-conseil/steps/step-connaissance-client/step-connaissance-client.component';
import { FicheConseilStateToggleSelectorComponent } from './components/my-fiches/fiche-conseil-dashboard/fiche-conseil-state-toggle-selector/fiche-conseil-state-toggle-selector.component';
import { FicheConseilTableMoreActionComponent } from './components/my-fiches/fiche-conseil-dashboard/fiche-conseil-table/fiche-conseil-table-more-action/fiche-conseil-table-more-action.component';
import { FicheConseilTableComponent } from './components/my-fiches/fiche-conseil-dashboard/fiche-conseil-table/fiche-conseil-table.component';
import { MyFichesComponent } from './components/my-fiches/my-fiches.component';
import { RenommerFicheDialogComponent } from './components/my-fiches/renommer-fiche-dialog/renommer-fiche-dialog.component';
import { AgeInYearsPipe } from './pipe/age-in-years.pipe';
import { MaritalStatusPipe } from './pipe/marital-status.pipe';
import { MontantPipe } from './pipe/montant.pipe';
import { OrderByPipe } from './pipe/order-by.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { ContratStepComponent } from './components/declare-fiche-conseil/steps/contrat-step/contrat-step.component';
import { ContratsTableComponent } from './components/declare-fiche-conseil/steps/contrats-table/contrats-table.component';

@NgModule({
  declarations: [
    AppComponent,
    MyFichesComponent,
    FicheConseilDashboardComponent,
    FicheConseilTableComponent,
    DeclareFicheConseilComponent,
    FicheConseilTableMoreActionComponent,
    FicheConseilStateToggleSelectorComponent,
    CreateFicheConseilComponent,
    NoneActiveHabilitationMessageComponent,
    StepConnaissanceClientComponent,
    InvestisseurStepComponent,
    SearchInvestisseurAutocompleteComponent,
    AgeInYearsPipe,
    MaritalStatusPipe,
    ExigencesStepComponent,
    TransactionPersonelleComponent,
    ProjetInvestissementStepComponent,
    ObjectifCheckboxComponent,
    SelectConseilConfigDialogComponent,
    OrderByPipe,
    PrecisionComplementaireStepComponent,
    VersementComponent,
    RenommerFicheDialogComponent,
    ModeDeGestionComponent,
    FondsEvenementielCheckboxComponent,
    OptionCheckboxComponent,
    MotivationOperationComponent,
    AllocationAssetComponent,
    AllocationZoneLibreDualTextareaComponent,
    AllocationConsultantFileUploadComponent,
    DeprecationWarningDialogComponent,
    ContratStepComponent,
    ContratsTableComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    LibModule,
    OuiLayoutModule,
    OuiDatePickerModule,
    OuiIconModule,
    OuiButtonModule,
    OuiTabsModule,
    OuiTagModule,
    OuiTableModule,
    OuiPaginatorModule,
    OuiNavButtonModule,
    OuiNavigationPanelModule,
    OuiRadioButton,
    OuiRadioButtonGroup,
    OuiRadioList,
    OuiInfosBulle,
    OuiStepper,
    OuiSlideToggle,
    OuiSelect,
    OuiLoadingModule,
    OuiSelectFilter,
    OuiAccordionModule,
    OuiTextfield,
    OuiTextarea,
    OuiCheckbox,
    OuiAutocomplete,
    OuiButtonToggle,
    OuiMenuModule,
    OuiSearchbar,
    OuiChipModule,
    OuiNumber,
    OuiBanner,
    OuiEtatVide,
    OuiFileUploader,
    OuiFileItem,
    OuiDialogModule,
    OuiSnackbarModule,
    OuiTooltipModule,
    MatDialogModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    GraphQLModule,
    AllocationRulesBannerComponent,
    MontantPipe,
    ReactiveFormsModule,
    CommonModule,
  ],
  exports: [MontantPipe],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: HTTP_INTERCEPTORS, multi: true, useClass: AuthInterceptorInterceptor },
    { provide: 'environment', useValue: environment },
    { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler },
    CurrencyPipe,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}

registerLocaleData(localeFr, 'fr-FR');
